import React, { useEffect } from "react";
import { useHits } from "react-instantsearch";
import { useDispatch } from "react-redux";
import { suggestionsActions } from "../../store/redux/store";

const CustomSuggestionsCollector = (props) => {
    const dispatch = useDispatch();
    const { hits } = useHits(props);

    const pushCollectedSuggestions = (payload) => {
        dispatch(suggestionsActions.pushSuggestions(payload));
    };

    const resetCollectionsSuggestions = () => {
        dispatch(suggestionsActions.resetSuggestions());
    };

    useEffect(() => {
        const customSuggestionsHits = hits;
        resetCollectionsSuggestions();
        customSuggestionsHits.map((element) => {
            return pushCollectedSuggestions(element.query);
        });
        // eslint-disable-next-line
    }, [hits]);

    return <></>;
};

export default CustomSuggestionsCollector;
